<h2 mat-dialog-title>Firma conjunta</h2>
<mat-dialog-content>
    <p>Se crear&aacute; nuevas tareas al remitente/s del documento para firma conjunta. Seguro desea continuar?</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Cerrar</button>
    <button class="update-button" (click)="firmaConjuntaCrearTareas()"
        [disabled]="fetchingFirmaConjuntaCrearNuevasTareas" mat-flat-button>
        <div class="btn-login-content">
            @if (fetchingFirmaConjuntaCrearNuevasTareas) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            <p>Aceptar</p>
            }
        </div>
    </button>
</mat-dialog-actions>
